export default __webpack_public_path__ + "static/media/webapp.c1bba94d.png";